import {createActions} from 'reduxsauce';

export const {Types: ContactUsTypes, Creators: ContactUsActionCreators} = createActions ({
    contactUsStart: null,
    contactUsSuccess: ['data'],
    contactUsFailure: ['error'],
    contactUsSendStart: ['data'],
    contactUsSendSuccess: ['data'],
    contactUsSendFailure: ['error'],
});